<!--
  -  Copyright (c) Qwoach LLC 2021. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 27/10/2021
  -->

<template>
	<qw-button type="circle" icon="icon-pencil" v-bind="listenersComputed"/>
</template>

<script>

import QwBaseButton from "@/core/components/Controls/Buttons/QwBaseButton.vue";

export default {
	name: "QwButtonEdit",
	extends: QwBaseButton,
	// inheritAttrs: false,
}
</script>

<style lang="scss">

</style>
